import { render } from "./CalloutBox.vue?vue&type=template&id=5a4126f7&scoped=true"
import script from "./CalloutBox.vue?vue&type=script&lang=js"
export * from "./CalloutBox.vue?vue&type=script&lang=js"

import "./CalloutBox.vue?vue&type=style&index=0&id=5a4126f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4126f7"]])

export default __exports__